import CookieApi from './CookieApi';

class CookieStorage implements Storage {
  data: any;

  readonly length: number = 0;

  constructor() {
    const val = '';
    if (CookieApi.hasPreferencesCookieConsent()) {
      document.cookie.replace(/(?:(?:^|.*;\s*)__ls\s*\=\s*([^;]*).*$)|^.*$/, '$1');
    }
    this.data = val.length > 0 ? JSON.parse(atob(val)) : {};
  }

  private writeCookie() {
    let val = JSON.stringify(this.data);
    val = btoa(val);
    document.cookie = `__ls=${val}; expires=Fri, 31 Dec 9999 23:59:59 GMT`;
  }

  setItem(key: string, val: string) {
    this.data[key] = val;
    if (CookieApi.hasPreferencesCookieConsent()) {
      this.writeCookie();
    }
  }

  getItem(key: string): string {
    return this.data[key];
  }

  removeItem(key: string) {
    delete this.data[key];
    this.writeCookie();
  }

  clear() {
    document.cookie = '__ls=; expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }

  key(): string | null {
    return null;
  }
}

let storageImpl: Storage;

function isLocalStorageEnabled() {
  try {
    if (!localStorage) {
      return false;
    }
    localStorage.setItem('_storage', '');
    localStorage.removeItem('_storage');
    return true;
  } catch (e) {
    return false;
  }
}

const getLocalStorageWrapper = (): Storage => ({
  setItem: (key: string, value: string): void => (CookieApi.hasPreferencesCookieConsent() ? localStorage.setItem(key, value) : undefined),
  getItem: (key: string) => localStorage.getItem(key),
  removeItem: (key: string) => localStorage.removeItem(key),
  key: (index: number) => localStorage.key(index),
  length: localStorage.length,
  clear: () => localStorage.clear()
});

export function getStorage() {
  if (!storageImpl) {
    storageImpl = isLocalStorageEnabled() ? getLocalStorageWrapper() : new CookieStorage();
  }

  return storageImpl;
}
